module.exports = __webpack_public_path__ + "resources/img/logo_partner_web_classting.d4531539e2f952605efc8a6af463126c.png";